import { supabase } from '../lib/supabase';

/**
 * Haalt het aantal openstaande acties op met exact dezelfde filters als ActiesPage.
 * Eén bron van waarheid voor badge én pagina.
 */
export async function fetchOpenActiesCount(coachId) {
  const now = new Date().toISOString();

  const [afgewezenRes, verlopenRes, prospectenRes, incassoRes, signedRes, dismissedRes] = await Promise.all([
    supabase
      .from('agreement_tokens')
      .select('id, client_id')
      .not('rejected_at', 'is', null)
      .not('rejected_by', 'is', null),

    supabase
      .from('agreement_tokens')
      .select('id, client_id')
      .is('used_at', null)
      .is('rejected_at', null)
      .lt('expires_at', now),

    supabase
      .from('profiles')
      .select('id')
      .eq('client_status', 'prospect'),

    supabase
      .from('invoices')
      .select('id')
      .eq('status', 'collections'),

    supabase.from('signed_agreements').select('client_id'),

    supabase.from('dismissed_actions')
      .select('reference_id, action_type')
      .eq('coach_id', coachId),
  ]);

  const signedClientIds = new Set((signedRes.data || []).map(s => s.client_id));
  const dismissedSet = new Set((dismissedRes.data || []).map(d => `${d.action_type}:${d.reference_id}`));

  const afgewezen = (afgewezenRes.data || []).filter(tk =>
    !signedClientIds.has(tk.client_id) &&
    !dismissedSet.has(`rejected_token:${tk.id}`)
  );

  const verlopen = (verlopenRes.data || []).filter(tk =>
    !signedClientIds.has(tk.client_id) &&
    !dismissedSet.has(`expired_token:${tk.id}`)
  );

  const prospects = (prospectenRes.data || []).filter(p =>
    !dismissedSet.has(`prospect:${p.id}`)
  );

  const incassoItems = (incassoRes.data || []).filter(inv =>
    !dismissedSet.has(`incasso:${inv.id}`)
  );

  return afgewezen.length + verlopen.length + prospects.length + incassoItems.length;
}
